module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "component-list flexcontainer full"
  }, _vm._l((_vm.items), function(item) {
    return _c('Item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3183ad01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gui/list/List.vue
// module id = 3110
// module chunks = 0